import clsx from "clsx";
import styles from "./Label.module.scss";

export const Label = ({ className = "", ...otherProps }) => {
  return <label {...otherProps} className={clsx(styles.label, className)} />;
};
